import { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { NavigationEntityType, useAIEntityPathResolver } from '@AppModels/hooks/useAIEntityPathResolver';
import { LoadingSpinner } from '../../components/LoadingSpinner';

interface AIResolverParams {
	entity: string;
	id: string;
	parentEntity?: string;
	parentId?: string;
}

export function AIResolver() {
	const { entity, id, parentEntity, parentId } = useParams<AIResolverParams>();
	const { resolveEntityPath } = useAIEntityPathResolver();
	const [redirectPath, setRedirectPath] = useState<string | null>(null);

	useEffect(() => {
		if (!entity || !id) {
			setRedirectPath('/dashboard');
			return;
		}

		const resolveNavigation = async () => {
			try {
				const directPath = await resolveEntityPath(
					entity as NavigationEntityType,
					id,
					parentEntity as NavigationEntityType,
					parentId
				);
				setRedirectPath(directPath);
			} catch (err) {
				console.error('AIResolver: Unsupported entity type:', entity, err);
				setRedirectPath('/dashboard');
			}
		};

		resolveNavigation();
	}, [entity, id, parentEntity, parentId, resolveEntityPath]);

	if (!redirectPath) {
		// Show loading state while resolving
		return <LoadingSpinner />;
	}

	return <Redirect to={redirectPath} />;
}
